import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button, Input, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

import { selectCustomStyles } from "../../../common/selectCustomStyles";

const SessionModal = ({
  modal,
  toggle,
  isEdit,
  session,
  sessionTypes = [],

  onSubmit
}) => {


  // 🔹 Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: session?.id || "",
      uuid: session?.uuid || '',
      title: session?.title || '',
      session_type_id: session?.session_type_id || '',
      start_date: session?.start_date || '',
      end_date: session?.end_date || '',
    
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Veuillez saisir le titre"),
      session_type_id: Yup.number().required("Veuillez sélectionner le type de session"),
      start_date: Yup.date().required("Veuillez saisir la date de début"),
      end_date: Yup.date().required("Veuillez saisir la date de fin"),
    
    }),
    onSubmit: values => {
      const payload = {
        ...values,
        session_type_id: Number(values.session_type_id),
       
      };
      onSubmit(payload);
    }
  });

  // 🔹 Sécurité supplémentaire : Reset au changement de mode (Ajout vs Edit)
  useEffect(() => {
    if (modal) {
      if (!isEdit) {
        formik.resetForm();
      }
    }
  }, [modal, isEdit]);





  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>
        {isEdit ? "Modifier - Session" : "Ajouter - Session"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col className="col-12">

              <div className="mb-3">
                <Label>Titre</Label>
                <Input
                  name="title"
                  type="text"
                  placeholder="Titre"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title || ""}
                  invalid={formik.touched.title && formik.errors.title}
                />
                {formik.touched.title && formik.errors.title && (
                  <FormFeedback type="invalid">{formik.errors.title}</FormFeedback>
                )}
              </div>

             
              <div className="mb-3">
                <Label>Type</Label>
                <Input
                  name="session_type_id"
                  type="select"
                  className="form-select"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.session_type_id || ""}
                  invalid={formik.touched.session_type_id && formik.errors.session_type_id}
                >
                  <option value="">-- Sélectionner --</option>
                  {sessionTypes.map(s => (
                    <option key={s.id} value={s.id}>{s.title}</option>
                  ))}
                </Input>
                {formik.touched.session_type_id && formik.errors.session_type_id && (
                  <FormFeedback type="invalid">{formik.errors.session_type_id}</FormFeedback>
                )}
              </div>

               <div className="mb-3">
                <Label>Date début</Label>
                <Input
                  name="start_date"
                  type="date"
                  placeholder="Date début"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.start_date || ""}
                  invalid={formik.touched.start_date && formik.errors.start_date}
                />
                {formik.touched.start_date && formik.errors.start_date && (
                  <FormFeedback type="invalid">{formik.errors.start_date}</FormFeedback>
                )}
              </div>

              <div className="mb-3">
                <Label>Date fin</Label>
                <Input
                  name="end_date"
                  type="date"
                  placeholder="Date fin"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.end_date || ""}
                  invalid={formik.touched.end_date && formik.errors.end_date}
                />
                {formik.touched.end_date && formik.errors.end_date && (
                  <FormFeedback type="invalid">{formik.errors.end_date}</FormFeedback>
                )}
              </div>








            </Col>
          </Row>

          <Row>
            <Col>
              <div className="text-end">
                <Button type="submit" color="primary">{isEdit ? "Modifier" : "Enregistrer"}</Button>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default SessionModal;